// Product name to route mapping
export const productRouteMap = {
  'Clean Room/Food Safe FIBC': '/products/fibc',
  'BOPP Bags': '/products/bopp-laminated-bags',
  'BOPP Laminated Bags': '/products/bopp-laminated-bags',
  'PE Liners': '/products/fibc',
  'Q-Bag': '/products/fibc',
  'Electrostatic FIBC': '/products/fibc',
  'UN FIBC': '/products/fibc',
  'Container Bags': '/products/fibc',
  'Ventilated FIBC': '/products/fibc',
  'PP Woven Bags': '/products/pp-woven-bags',
  'PP Woven Sacks/Bags': '/products/pp-woven-bags',
  'PP Rolls': '/products/pp-rolls',
  '1 & 2 Loop': '/products/fibc',
  '1 & 2 Loops': '/products/fibc',
  'Builder Bags': '/products/fibc',
  'Builder': '/products/fibc',
  'Tarpaulins': '/products',
  'Tarps': '/products',
  'Tarp': '/products',
  'Garden Bags': '/products',
  'Planter Bags': '/products',
  'Vermibed': '/products',
  'Technical Textiles': '/products',
  'Custom Packaging': '/products',
  'Laminated Woven Bags': '/products/laminated-woven-bags',
  'FIBC': '/products/fibc'
};

// Get route for a product name
export const getProductRoute = (productName) => {
  return productRouteMap[productName] || '/products';
};

